import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=653df676&scoped=true"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"
import style0 from "./uploader.vue?vue&type=style&index=0&id=653df676&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653df676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653df676')) {
      api.createRecord('653df676', component.options)
    } else {
      api.reload('653df676', component.options)
    }
    module.hot.accept("./uploader.vue?vue&type=template&id=653df676&scoped=true", function () {
      api.rerender('653df676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-manage/components/uploader.vue"
export default component.exports